import { Mic, Send } from '@mui/icons-material';
import { Dialog, DialogContent } from '@mui/material';
import React,{useState,useRef} from 'react'
import SpeechConfig from '../../../../components/SpeechConfig'
import AppLayout from '../../../../layout/components/AppLayout'

function BotPage() {
    const [msgLog,setMsgLog] = useState([]);
    const [msg,setMsg] = useState("");
    const [dialogStatus, setDialogStatus] = useState(false);
    const messagesEndRef = useRef(null);

    const submitMessage = () => {
        //setNewChat({deviceName : "You",msg:msg})
        setMsgLog(()=>[...msgLog,{deviceName : "You",msg:msg}])
        setMsg("");
    }


    const listen = () =>{
        let SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        let r = new SR();
        //console.log(r);
        r.start();
        r.onstart = (e) =>{
            //setMsg("");
            setDialogStatus(true);
            //console.log("Started")
        }
        r.onend = (e) =>{
            setDialogStatus(false);
            //console.log("ended")
        }
        r.onresult = (e) =>{
            console.log(e);
            console.log(e.results[0][0].transcript)
            setMsg(e.results[0][0].transcript)
            setMsgLog(()=>[...msgLog,{deviceName : "You",msg:e.results[0][0].transcript}])
            //setListenValue(e.results[0][0].transcript);
        }
    }


    return (
        <AppLayout>
            <div className="container-fluid">
                <SpeechConfig/>
                <div className="row flex-row-reverse">
                    
                    <div className="col-md-4">
                        <div className="card">
                            <div className="border border-primary p-2 rounded" style={{overflowY:"auto",height:300, maxHeight:300}} >
                                {msgLog.map((log,i)=>
                                    <p key={i} > <span className="fw-bold">{log.deviceName}</span> : {log.msg}</p>
                                )}
                                <div ref={messagesEndRef}></div>
                            </div>
                            <div className="input-group">
                                <input type="text" className="form-control" value={msg} onChange={(e)=>setMsg(e.target.value)} />
                                <button type="button" className="btn btn-outline-default" onClick={listen} ><Mic /></button>
                                <button type="button" className="btn btn-primary" onClick={submitMessage} ><Send /></button>
                            </div>
                            <Dialog
                                open={dialogStatus}
                                maxWidth="md"
                            >
                                <DialogContent>
                                    <h4>Listning...</h4>
                                    <div className='gtoken-mic'></div>
                                </DialogContent>

                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default BotPage